import React from 'react';
import WaitingListTab from './WaitingListTab';

export default function JavaTab() {
  return <WaitingListTab languageKey="java" languageName="Java" />;
}
